import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles(theme => ({
    keytxt: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#091E42",
        marginTop: "30px"
    },
    tagInput: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "15px 14px",
        width: "330px",
        height: "52px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        marginTop: "10px",
        boxSizing: "border-box",
        borderRadius: "8px"
    },
    addButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "15px 20px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        marginTop: 60
    },
    txt: {
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#091E42"
    }
}))